"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeFunction = exports.getAbiInputsOutputs = exports.getAbiInputsOutputsType = void 0;
const abi_coder_1 = require("@ethersproject/abi/lib/abi-coder");
const abi_1 = require("@ethersproject/abi");
const getAbiInputsOutputsType = (abi, method) => {
    const abiItem = abi.find((item) => item.name === method);
    if (!abiItem) {
        throw new Error('ABI not found');
    }
    return {
        inputs: abiItem.inputs.map((input) => input.type),
        outputs: abiItem.outputs.map((output) => output.type),
        outputNames: abiItem.outputs
            .filter((output) => !!output.name)
            .map((output) => output.name),
    };
};
exports.getAbiInputsOutputsType = getAbiInputsOutputsType;
const getAbiInputsOutputs = (abi, method) => {
    const abiItem = abi.find((item) => item.name === method);
    if (!abiItem) {
        throw new Error('ABI not found');
    }
    return {
        inputs: abiItem.inputs,
        outputs: abiItem.outputs,
    };
};
exports.getAbiInputsOutputs = getAbiInputsOutputs;
const encodeFunction = (method, params = [], inputs = []) => {
    const methodWithParameters = `function ${method}(${inputs.join(',')})`;
    const signatureHash = new abi_1.Interface([methodWithParameters]).getSighash(method);
    const paramStringAbi = (params.length ? abi_coder_1.defaultAbiCoder.encode(inputs, params) : '').slice(2);
    return signatureHash.slice(2) + paramStringAbi;
};
exports.encodeFunction = encodeFunction;
